import { render, staticRenderFns } from "./FedExDisclaimer.vue?vue&type=template&id=0127b017&scoped=true&"
import script from "./FedExDisclaimer.vue?vue&type=script&lang=js&"
export * from "./FedExDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./FedExDisclaimer.vue?vue&type=style&index=0&id=0127b017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0127b017",
  null
  
)

export default component.exports